// Minimal subset of wizard-schemas needed by admin components (BriefDisplay etc.)

export const STYLE_PREFERENCES = [
  { value: "modern", label: "Modern", description: "Clean, current, tech-forward" },
  { value: "minimal", label: "Minimal", description: "Lots of whitespace, quiet" },
  { value: "corporate", label: "Corporate", description: "Professional and trustworthy" },
  { value: "bold", label: "Bold", description: "Strong color, big type" },
  { value: "playful", label: "Playful", description: "Friendly, warm, approachable" },
] as const;

export type StylePreference = (typeof STYLE_PREFERENCES)[number]["value"];

export const PREFERRED_CONTACT_OPTIONS = ["email", "whatsapp", "either"] as const;
export type PreferredContact = (typeof PREFERRED_CONTACT_OPTIONS)[number];
